import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./shadcn-ui.css";
import "./components/side-modal/side-modal.style.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { LocalDraftsProvider } from "./context/local-drafts.context";

// tanstack query
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./global/query-client";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	// <React.StrictMode>
	<QueryClientProvider client={queryClient}>
		<LocalDraftsProvider>
			<App />
		</LocalDraftsProvider>
		{process.env.NODE_ENV === "development" && (
			<ReactQueryDevtools initialIsOpen={false} />
		)}
	</QueryClientProvider>
	// </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
